export default __webpack_public_path__ + "static/media/berhe.59a49081.jpg";